import { useState } from "react";
import PropTypes from "prop-types";
import MDBox from "theme/components/MDBox";
import MDInput from "theme/components/MDInput";
import { Snackbar, Alert } from "@mui/material";

function NINField({ displayName, fieldRef, isOptional, options }) {
  const [fieldError, showFieldError] = useState(false);

  return (
    <MDBox>
      <MDInput
        name={fieldRef}
        id={`dff_${fieldRef}`}
        margin="dense"
        label={displayName}
        type="text"
        fullWidth
        variant="outlined"
        onBlur={(e) => {
          const nin = e.target.value;
          const isnum = /^\d+$/.test(nin);
          if (!isnum || nin.length !== 11) {
            e.target.value = null;
            showFieldError(true);
          }
        }}
        options={options}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          Invalid NIN provided.
        </Alert>
      </Snackbar>
    </MDBox>
  );
}

// Typechecking props of the Transaction
NINField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

NINField.defaultProps = {
  options: null,
};

export default NINField;
